import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { InfoIcon } from '@phosphor-icons/react/Info';

import type { JSX } from 'react';

type InlineInfoProps = {
  infoText: string | JSX.Element;
};

export const InlineInfo = ({ infoText }: InlineInfoProps) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        marginLeft: theme => theme.spacing(-1),
        marginTop: theme => theme.spacing(1),
      }}
    >
      <IconButton data-test="tooltip-icon" sx={{ marginRight: theme => theme.spacing(1) }}>
        <InfoIcon />
      </IconButton>

      <Typography data-test="targeting-inline-info">{infoText}</Typography>
    </Box>
  );
};
